<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 border-bottom">
            <div class="d-flex justify-content-center align-items-center">
              <div class="col-md-12"><h6>Nuevo contrato compra-venta</h6></div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2 vh-50">
            <div class="container py-4">
              <form
                class="w-100 px-md-5"
                method="POST"
                id="formContrato"
                @submit.prevent="storeContratoCompraVenta"
              >
                <DatosGenerales />
                <DetallePagos />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useContratosStore from '@/store/contratos'
import DatosGenerales from "./DatosGenerales";
import DetallePagos from "./DetallePagos";

export default {
  name: "Crear-Contrato-Domiciliacion",
  components: {
    DatosGenerales,
    DetallePagos,
  },
  computed: {},
  setup() {
    const { storeContratoCompraVenta } = useContratosStore();

    return {
      storeContratoCompraVenta,
    };
  },
};
</script>

<style></style>
